import img1 from '../assets/Quality.jpg'
import img2 from '../assets/GMP.jpg'
import img3 from '../assets/Approvals.jpg'
import img4 from '../assets/Expertise.jpg'
import img5 from '../assets/Ideas.jpg'

export const BsliderData = [
    {
      image: img1,
      heading: "Commitment to Quality",
      desc: "With the Anthem Biosciences as a partner, we are committed to the best manufacturing standards and procedures to our products",
    },
    {
      image: img2,
      heading: "GMP facility approved by USFDA",
      desc: "One of the gold standards which are procured to very few of the numero unos and we are one of them",
    },
    {
      image: img3,
      heading: "Necessary Regulatory Approvals",
      desc: "With the India's Pharmaceutical Industry on boom, we always strive to perfection in approvals and authentication of our products and its manufacturing practices",
    },
    {
      image: img4,
      heading: "Technical Expertise",
      desc: "We follow the best operating procedure in our laboratory with each dedicated facility for Chemical, Biological, Biologics development and Product research",
    },
    {
      image: img5,
      heading: "Innovative ideas and cost-effective solutions",
      desc: "Backed by Anthem's top class R&D and GMP standards in analytics, research and testing",
    }
  ];